import { motion } from "framer-motion"
import React from "react"
import { IphoneMockup } from "./elements/iPhoneMockup"

// Images
import screen1 from "/public/images/screenshots/1.jpg"
import screen2 from "/public/images/screenshots/2.jpg"
import screen3 from "/public/images/screenshots/3.jpg"
import screen4 from "/public/images/screenshots/4.jpg"
import screen5 from "/public/images/screenshots/5.jpg"
import screen6 from "/public/images/screenshots/6.jpg"
import screen7 from "/public/images/screenshots/7.jpg"
import screen8 from "/public/images/screenshots/8.jpg"

export const FeaturesPageHead: React.FC = (props) => {
  const cols = {
    hidden: { opacity: 1 },
    show: {
      opacity: 1,
    },
  }

  const mocks = {
    hidden: { opacity: 0, y: "-400px" },
    show: {
      opacity: 1,
      y: "0",
      transition: {
        ease: "easeOut",
        duration: 0.6,
      },
    },
  }

  return (
    <div className='features-page-head'>
      {/* COL 1 ------------------------------ */}
      <motion.div
        className='col'
        variants={cols}
        initial='hidden'
        animate='show'
        exit='hidden'
        transition={{ delayChildren: 0.5, staggerChildren: 0.2, staggerDirection: -1 }}
      >
        <motion.div variants={mocks}>
          <IphoneMockup image={screen1} />
        </motion.div>
      </motion.div>

      {/* COL 2 ------------------------------ */}
      <motion.div
        className='col'
        variants={cols}
        initial='hidden'
        animate='show'
        exit='hidden'
        transition={{ delayChildren: 0.1, staggerChildren: 0.2, staggerDirection: -1 }}
      >
        <motion.div variants={mocks}>
          <IphoneMockup image={screen2} />
        </motion.div>
        <motion.div variants={mocks}>
          <IphoneMockup image={screen3} />
        </motion.div>
      </motion.div>

      {/* COL 3 ------------------------------ */}
      <motion.div
        className='col'
        variants={cols}
        initial='hidden'
        animate='show'
        exit='hidden'
        transition={{ delayChildren: 0.3, staggerChildren: 0.2, staggerDirection: -1 }}
      >
        <motion.div variants={mocks}>
          <IphoneMockup image={screen4} />
        </motion.div>
      </motion.div>

      {/* COL 4 ------------------------------ */}
      <motion.div
        className='col'
        variants={cols}
        initial='hidden'
        animate='show'
        exit='hidden'
        transition={{ delayChildren: 0.2, staggerChildren: 0.2, staggerDirection: -1 }}
      >
        <motion.div variants={mocks}>
          <IphoneMockup image={screen5} />
        </motion.div>

        {/* COL 5 ------------------------------ */}
      </motion.div>
      <motion.div
        className='col'
        variants={cols}
        initial='hidden'
        animate='show'
        exit='hidden'
        transition={{ delayChildren: 0.4, staggerChildren: 0.2, staggerDirection: -1 }}
      >
        <motion.div variants={mocks}>
          <IphoneMockup image={screen6} />
        </motion.div>
        <motion.div variants={mocks}>
          <IphoneMockup image={screen7} />
        </motion.div>

        {/* COL 6 ------------------------------ */}
      </motion.div>
      <motion.div
        className='col'
        variants={cols}
        initial='hidden'
        animate='show'
        exit='hidden'
        transition={{ delayChildren: 0.6, staggerChildren: 0.2, staggerDirection: -1 }}
      >
        <motion.div variants={mocks}>
          <IphoneMockup image={screen8} />
        </motion.div>
      </motion.div>
    </div>
  )
}
